import {
    actionCreator,
    checkHttpStatus, 
    jsonApiHeader, 
    showErrorMessage, 
    showSuccessMessage, 
    showWarningMessage,
    rawAbcDataActionTypes,      
    GET_RAWABCDATA_LIST_API,     
    DELETE_RAWABCDATA_API,
} from '../constants/ApiConstants';

import Alert from 'react-s-alert';
import { createSearchUrlForCustomAPI } from '../../../../../../../actions/utilAction';



export const getRawABCDataList = (searchObj) => {
    let query_params = createSearchUrlForCustomAPI(searchObj);
    return (dispatch, getState) => {
        dispatch(actionCreator(rawAbcDataActionTypes.get_rawABCDataList.REQUEST));
        fetch(`${GET_RAWABCDATA_LIST_API}${query_params}`, {
            method: 'get',
            headers: jsonApiHeader(getState().login.access_token, 'application/json'),
        })
            .then(checkHttpStatus)
            .then(function (response) {
                if (response.statusCode >= 200 && response.statusCode < 300 && response.statusCode !== 204) {
                    dispatch(actionCreator(rawAbcDataActionTypes.get_rawABCDataList.SUCCESS, response));
                } else {
                    dispatch(actionCreator(rawAbcDataActionTypes.get_rawABCDataList.SUCCESS, null));
                }
            }).catch(function (error) {
                console.log('error get_rawABCDataList', error);
            });
    };
};

export const deleteRawABCData = (recordABCDataId) => {
    Alert.closeAll();
    return (dispatch, getState) => {
        dispatch(actionCreator(rawAbcDataActionTypes.delete_rawABCData.REQUEST));
        fetch(`${DELETE_RAWABCDATA_API}?recordABCDataId=${recordABCDataId}`, {
            method: 'PATCH',
            headers: jsonApiHeader(getState().login.access_token, 'application/json'),
        })
            .then(checkHttpStatus)
            .then((response) => {
                if (response.statusCode >= 200 && response.statusCode < 300 && response.statusCode !== 204) {
                    showSuccessMessage(response.message);
                    dispatch(actionCreator(rawAbcDataActionTypes.delete_rawABCData.SUCCESS, response));
                } else if (response.statusCode === 401 || response.statusCode === 422) {
                    showWarningMessage(response.message);
                    dispatch(actionCreator(rawAbcDataActionTypes.delete_rawABCData.SUCCESS, null));
                } else {
                    showErrorMessage(response.message);
                    dispatch(actionCreator(rawAbcDataActionTypes.delete_rawABCData.SUCCESS, null));
                }
            }).catch(function (error) {
                console.log('error delete_rawABCData', error);
            });
    };
};



// WEBPACK FOOTER //
// ./src/modules/patients/components/DataCollection/BehaviorReductiom/RawABCData/actions/rawABCDataActions.js